/**
 * Product page interactions: quantity stepper and gallery thumbnail swap.
 */
(function () {
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('.js-qty-decrease');
    var inc = e.target.closest('.js-qty-increase');
    if (dec || inc) {
      e.preventDefault();
      var input = document.getElementById('ProductQuantity');
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      value = dec ? Math.max(1, value - 1) : value + 1;
      input.value = value;
      document.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
        btn.setAttribute('data-quantity-input', 'ProductQuantity');
      });
      return;
    }

    var thumb = e.target.closest('.js-product-thumb');
    if (thumb) {
      e.preventDefault();
      var img = document.getElementById('MainProductImage');
      if (img) img.src = thumb.getAttribute('data-image-url');
      thumb.parentElement.parentElement.querySelectorAll('.js-product-thumb').forEach(function (b) {
        b.classList.remove('border-terracotta-500');
        b.classList.add('border-terracotta-200');
      });
      thumb.classList.remove('border-terracotta-200');
      thumb.classList.add('border-terracotta-500');
    }
  });
})();
